// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import topNav from './components/commons/Header'
import pageFooter from './components/commons/Footer'
import './utils/flexible'
import '../static/common/common.css'
import ElementUi from "element-ui"
import 'element-ui/lib/theme-chalk/index.css'
import VueI18n from 'vue-i18n'

router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
});
Vue.config.productionTip = false
Vue.component("topNav", topNav)
Vue.component("pageFooter", pageFooter)
Vue.use(ElementUi)
Vue.use(VueI18n)
const i18n = new VueI18n({
  locale: 'CN',
  messages: {
    'CN': require('./i18n/languages/CN'),
    'EN': require('./i18n/languages/EN'),
    'TW': require('./i18n/languages/TW')
  }
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js